import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import ClientHelper from "core/ClientHelper";
import DateHelper from "core/DateHelper";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { GenericAsyncAutocomplete, GenericDateInput, GenericEmailInput, GenericExpansionPanel, GenericLabel, GenericNumberInput, GenericSelectInput, GenericTextInput, GenericTitle, GenericCheckInput } from "views/Components/Generic";
import { ProgramCodes, IdentityType } from "views/Constants/Constant.js";
import ParameterComponent from "views/Components/ParameterComponent";
import CardBody from "components/Card/CardBody";
import { IdentificationMethod } from "views/Constants/Constant";
import { CustomerTaxJurisdictionQuestionnaireReason } from "views/Constants/Constant";

import { TaskPool } from "core/TaskPool";
import { SignalCellularNullOutlined } from "@material-ui/icons";

class CustomerInformationComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			identificationMethodIds: [],
			taxJurisdictionQuestionnaireReasonIds: [],
			refugeeIdentityTypeId: 0
		};

		this.maxLength15 = { maxLength: 15 };
		this.maxLength20 = { maxLength: 20 };
		this.maxLength30 = { maxLength: 30 };
		this.maxLength35 = { maxLength: 35 };
		this.maxLength60 = { maxLength: 60 };
		this.maxLength64 = { maxLength: 64 };
		this.maxLength100 = { maxLength: 100 };
		this.marginLeft2 = { marginLeft: 2 };

		this.emptyObject = {};

		this.ParameterClientType = {
			ParameterCode: "ClientType",
			ParameterValue3: "D"
		};

		this.ParameterIdentificationMethod = {
			ParameterCode: "IdentificationMethod",
			ParameterValue2: "Active"
		};

		this.ParameterIdentityType = {
			ParameterCode: "IdentityType" // ParameterCode: "IdentityType2"
			// ,ParameterValue2: "PrimaryId"
			// Commented to Display the more frequent ID types on Database...
		};

		this.ParameterProvincialGovermentPhotoId = {
			ParameterCode: "ProvincialGovermentPhotoId"
		};

		this.ParameterIdentitySecondary = {
			ParameterCode: "IdentityType" // ParameterCode: "IdentityType2"
		};

		this.ParameterResidencyCountry = {
			ParameterCode: "ResidencyCountry"
		};

		this.ParameterLanguage = {
			ParameterCode: "Language"
		};

		this.ParameterYesNo = {
			ParameterCode: "YesNo"
		};

		this.YesNoOptions = [
         { ParameterValue: "true", ParameterDesc: "Yes" },
         { ParameterValue: "false", ParameterDesc: "No" },
      ];

		this.ParameterGender = {
			ParameterCode: "Gender"
		};

		this.ParameterCustomerStatus = {
			ParameterCode: "CustomerStatus"
		};

		this.ParameterIntendedUse = {
			ParameterCode: "IntendedUse"
		};

		this.ParameterCreditAgency = {
			ParameterCode: "CreditAgency"
		};

		this.ParameterPrimarySourceForDualProcessId = {
			ParameterCode: "DocumentForDualProcessIdentification",
			ParameterValue2: "PrimaryDocument"
		};

		this.ParameterSecondarySourceForDualProcessId = {
			ParameterCode: "DocumentForDualProcessIdentification",
		};

		this.sortedOrderIndex = { Member: "OrderIndex" };
		this.sortedParameterDesc = { Member: "ParameterDesc" };
		this.sortedParameterValue2 = { Member: "ParameterValue2" };

		this.renderItemPhoneCode = {};

		this.specificIdentityTypesIds = [];

		this.ParameterTaxJurisdictionQuestionnaireNoTinReason = {
			ParameterCode: "CustomerTaxJurisdictionQuestionnaireReason"
		};
	}

	componentDidMount() {	
		
	}

	componentWillMount() {
		this.GetIdentificationMethodIds();
		this.GetTaxJurisdictionQuestionnaireReasonIds();
	}

	RenderItemPhoneCode = (d) => {
		this.renderItemPhoneCode = "+" + d.Code + " (" + d.Name + ")";
		return this.renderItemPhoneCode;
	}

	IsNullOrEmpty(value) {
		return (value == null || value === "" || value === '' 
									 || value === '""' || value === '""');
	}
	
	GetIdentificationMethodIds() {
		Proxy.POST(
			"/coreapi/v1.0/Parameter/Search",
			{
				ParameterCode: "IdentificationMethod",
				ParameterValue2: "Active"			
			},
			(responseData) => {
				if (!responseData.IsSucceeded) {
					console.log("Parameters were not found.");
					return;
				}
				let list = responseData.Item;
				let methods = [];
				for(var i=0; i<list.length; i++) {
					let method = {
						"Id" :	list[i].Id,
						"Value" : list[i].ParameterValue
					};
					methods.push(method);	
				}
				this.setState({identificationMethodIds: methods});
				this.OnLoadedIDMethods();				
			}			
		);	
	}

	GetTaxJurisdictionQuestionnaireReasonIds() {
		Proxy.POST(
			"/coreapi/v1.0/Parameter/Search",
			{
				ParameterCode: "CustomerTaxJurisdictionQuestionnaireReason"		
			},
			(responseData) => {
				if (!responseData.IsSucceeded) {
					console.log("Parameters were not found.");
					return;
				}
				let list = responseData.Item;
				let reasons = [];
				for(var i=0; i<list.length; i++) {
					let method = {
						"Id" :	list[i].Id,
						"Value" : list[i].ParameterValue
					};
					reasons.push(method);	
				}
				this.setState({taxJurisdictionQuestionnaireReasonIds: reasons});
				this.OnLoadedIDMethods();				
			}			
		);	
	}

	OnLoadedIDMethods() {
		this.GetSpecificIdentityTypesIds();
		this.GetRefugeeIdentityTypeId();
	}

	GetRefugeeIdentityTypeId() {
		Proxy.POST(
			"/coreapi/v1.0/Parameter/Search",
			{
				ParameterCode: "IdentityType",
				ParameterValue: IdentityType.RefugeeProtectionIdentityDocument
			},
			(responseData) => {
				if (!responseData.IsSucceeded) {
					console.log("Parameters were not found.");
					return;
				}
				const refugeeType = responseData.Item?.find(x => x.ParameterValue === IdentityType.RefugeeProtectionIdentityDocument);
				this.setState({ refugeeIdentityTypeId: refugeeType?.Id ?? 0 });
			}
		);
	}

	GetSpecificIdentityTypesIds() {
		Proxy.POST(
			"/coreapi/v1.0/Parameter/Search",
			{
				ParameterCode: "IdentityType2",
				ParameterValue: "ID010"
			},
			(responseData) => {
				if (!responseData.IsSucceeded) {
					console.log("Parameters were not found.");
					return;
				}
				let list = responseData.Item;												
				list.forEach(element => {
					this.specificIdentityTypesIds.push(element.Id);
				});	
			}
		);
	}

	render() {
		const { model, tempModel, vModel, wCheckModel, Title, ReadOnly, Disabled, ForInsert } = this.props;
		
		var IsIncludeEFT = model.Programs.includes(ProgramCodes.Bank_Programs_EFT);
		var IsIncludeET = model.Programs.includes(ProgramCodes.Bank_Programs_e_Transfer);
		var IsIncludeCDIC = model.Programs.includes(ProgramCodes.Bank_Programs_CDIC);
		var IsIncludePrepaid = model.Programs.includes("WALLET");
		var IsIncludeLender = model.Programs.includes(ProgramCodes.Lender);
		var IsFilledPhoneNumber = model.PhoneCountryCodeId > 0 && model.PhoneNumber;

		var disabledIdVerification = !(tempModel.isPersonal && (IsIncludePrepaid));
		var disabledTaxQuestionary = !IsIncludePrepaid || !tempModel.isPersonal;
		const isRefugeeProtectionDoc = this.state.refugeeIdentityTypeId > 0
			&& model.IdentityTypeId === this.state.refugeeIdentityTypeId;
		const isSecondaryRefugeeProtectionDoc = this.state.refugeeIdentityTypeId > 0
			&& model.SecondaryIdentityTypeId === this.state.refugeeIdentityTypeId;
		
		model.IdentityVerifyingPersonId = ClientHelper.GetUser().Id; 
				
		return (
				<GenericExpansionPanel Title={Title}>
					<GridContainer>
						<GridItem xs={4}>
							<GenericTitle text={"Customer General Information"} />
							<>
								<GridItem>
									<GenericSelectInput
										Name="ClientTypeId"
										LabelText="Customer Type"
										Method="POST"
										Url="/coreapi/v1.0/Parameter/Search"
										Parameter={this.ParameterClientType}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="ParameterDesc"
										Value={model.ClientTypeId}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly || model.Id > 0}
										Required = {!ReadOnly}
										IsInvalid={vModel.ClientType}
										AfterFetchCallback={this.props.AfterFetchCallback} />
								</GridItem>
								<GridItem>
									<GenericSelectInput
										Name="CustomerStatusId"
										LabelText="Customer Status"
										Method="POST"
										Url="/coreapi/v1.0/Parameter/Search"
										Parameter={this.ParameterCustomerStatus}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="ParameterDesc"
										Value={model.CustomerStatusId}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly}
										Required = {(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
										IsInvalid={vModel.CustomerStatus}/>
								</GridItem>
								<GridItem>
									<GenericSelectInput
										Name="IntendedUseId"
										LabelText="Intended Use"
										Method="POST"
										Url="/coreapi/v1.0/Parameter/Search"
										Parameter={this.ParameterIntendedUse}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="ParameterDesc"
										Value={model.IntendedUseId}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly}
										Required = {(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
										IsInvalid={vModel.IntendedUse}
										RenderItem={d => `${d.ParameterValue} (${d.ParameterDesc})`}/>
								</GridItem>
								<GridItem>
									<GenericSelectInput
										Name="IsCustomerPep"
										LabelText="Is Customer a PEP"
										Value={model?.IsCustomerPep == null	? null : String(model.IsCustomerPep)}
										ValueChanged={this.props.handleChange}
										StaticData={this.YesNoOptions}
										KeyValueMember="ParameterValue"
										TextValueMember="ParameterDesc"
									/>
								</GridItem>
								<GridItem style={{ opacity: tempModel.isPersonal === true ? 0.4 : 1 }}>
									<GenericTextInput
										Name="CompanyLegalName"
										LabelText="Legal Name"
										Value={model.CompanyLegalName}
										ValueChanged={this.props.handleChange}
										Disabled={tempModel.isPersonal === true || ReadOnly}
										Required={tempModel.isPersonal === false && !ReadOnly}
										IsInvalid={vModel.CompanyLegalName}
										inputProps={this.maxLength30} />
								</GridItem>
								<GridItem style={{ opacity: tempModel.isPersonal === true ? 0.4 : 1 }}>
									<GenericTextInput
										Name="BusinessIdNumber"
										LabelText="Business ID Nr. (BIN)"
										Value={model.BusinessIdNumber}
										ValueChanged={this.props.handleChange}
										Disabled={tempModel.isPersonal === true || ReadOnly}
										Required={tempModel.isPersonal === false && (IsIncludeCDIC || IsIncludeEFT || IsIncludeET || IsIncludeLender || IsIncludePrepaid)
																							  && !ReadOnly}
										IsInvalid={vModel.BusinessIdNumber}
										inputProps={this.maxLength30} />
								</GridItem>
								<GridItem style={{ opacity: tempModel.isPersonal === true ? 0.4 : 1 }}>
									<GenericTextInput
										Name="BusinessName"
										LabelText="Business Name"
										Value={model.BusinessName}
										ValueChanged={this.props.handleChange}
										Disabled={tempModel.isPersonal === true || ReadOnly}
										Required={tempModel.isPersonal === false && !ReadOnly}
										IsInvalid={vModel.BusinessName}
										inputProps={this.maxLength30} />
								</GridItem>
								{IsIncludeET &&
									<>
										<GridItem style={{ opacity: tempModel.isPersonal === true ? 0.4 : 1 }}>
											<GenericTextInput
												Name="CompanyName"
												LabelText="Company Name"
												Value={model.CompanyName}
												ValueChanged={this.props.handleChange}
												Disabled={tempModel.isPersonal === true || ReadOnly}
												Required={tempModel.isPersonal === false && !ReadOnly}
												IsInvalid={vModel.CompanyName}
												inputProps={this.maxLength30} />
										</GridItem>
										<GridItem style={{ opacity: tempModel.isPersonal === true ? 0.4 : 1 }}>
											<GenericTextInput
												Name="RegistrationName"
												LabelText="Registration Name"
												Value={model.RegistrationName}
												ValueChanged={this.props.handleChange}
												Disabled={tempModel.isPersonal === true || ReadOnly}
												Required={tempModel.isPersonal === false && !ReadOnly}
												IsInvalid={vModel.RegistrationName}
												inputProps={this.maxLength30} />
										</GridItem>
										<GridItem style={{ opacity: tempModel.isPersonal === true ? 0.4 : 1 }}>
											<GenericTextInput
												Name="RetailName"
												LabelText="Retail Name"
												Value={model.RetailName}
												ValueChanged={this.props.handleChange}
												Disabled={tempModel.isPersonal === true || ReadOnly}
												Required={tempModel.isPersonal === false && !ReadOnly}
												IsInvalid={vModel.RetailName}
												inputProps={this.maxLength30} />
										</GridItem>
									</>
								}
								<GridItem>
									<GenericTextInput
										Name="Name"
										LabelText="First Name"
										Value={model.Name}
										ValueChanged={this.props.handleChange}

										Disabled={ReadOnly}
										inputProps={this.maxLength35}
										Required={tempModel.isPersonal === true && !ReadOnly}
										Hidden={tempModel.isPersonal === false || ReadOnly} />

								</GridItem>
								<GridItem style={{ opacity: tempModel.isPersonal === false ? 0.4 : 1 }}>
									<GenericTextInput
										Name="MiddleName"
										LabelText="Middle Name"
										Value={model.MiddleName}
										ValueChanged={this.props.handleChange}
										Disabled={tempModel.isPersonal === false || ReadOnly}
										inputProps={this.maxLength30} />
								</GridItem>
								<GridItem>
									<GenericTextInput
										Name="SurName"
										LabelText="Last Name"
										Value={model.SurName}
										ValueChanged={this.props.handleChange}

										Disabled={ReadOnly}
										inputProps={this.maxLength35} 
										Required={tempModel.isPersonal === true && !ReadOnly}
										Hidden={tempModel.isPersonal === false || ReadOnly} />
								</GridItem>
								<GridItem style={{ opacity: tempModel.isPersonal === false ? 0.4 : 1 }}>
									<GenericDateInput
										Name="BirthDate"
										LabelText="Date of Birth"
										Value={model.BirthDate ? DateHelper.ToDateInputValue(model.BirthDate) : ""}
										ValueChanged={this.props.handleChange}
										IncludeTime={false}
										IsPast={true}
										Utc={true}
										Disabled={tempModel.isPersonal === false || ReadOnly}
										Required={tempModel.isPersonal === true && (IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
										IsInvalid={vModel.BirthDate} />
								</GridItem>
								<GridItem>
									<GenericSelectInput
										Name="GenderId"
										LabelText="Gender"
										Method="POST"
										Url="/coreapi/v1.0/Parameter/Search"
										Parameter={this.ParameterGender}
										DataRoot="Item"
										Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
										KeyValueMember="Id"
										TextValueMember="ParameterDesc"
										Value={model.GenderId}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly}
										Hidden={tempModel.isPersonal === false || ReadOnly} />
								</GridItem>
								<GridItem>
									<GenericAsyncAutocomplete
										key={`occupation-${model.OccupationId ?? model.Occupation?.Id ?? "empty"}-${model.Occupation?.Name ?? model.Occupation?.ParameterDesc ?? "empty"}`}
										Name="OccupationId"
										LabelText="Occupation"
										Url="/coreapi/v2.0/Parameter/GetOccupationList"
										GetByIdUrl="/coreapi/v2.0/Parameter/GetOccupationListById"
										DataRoot="Item"
										Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
										KeyValueMember="Id"
										TextValueMember="Name"
										Value={model.OccupationId ?? model.Occupation?.Id ?? ""}
										DefaultText={model.Occupation?.Name ?? model.Occupation?.ParameterDesc ?? ""}
										ValueChanged={(name, value, data) => {
											this.props.handleChange("OccupationId", value, data);
											if (data) {
												this.props.handleChange("Occupation", { Id: data.Id, Name: data.Name, RiskRating: data.RiskRating });
											}
										}}
										Disabled={ReadOnly}
										Hidden={tempModel.isPersonal === false}
										MinLength={3}
										DebounceMs={500}
										IsInvalid={vModel.Occupation} />
								</GridItem>

								<GridItem>
									<GridItem xs={8}>
										<br/>
										<b>Employer Information</b>
									</GridItem>
									<GridItem>
										<GenericTextInput
											Name="EmployerName"
											LabelText="Employer"
											Value={model.EmployerName}
											ValueChanged={this.props.handleChange}
											Disabled={!tempModel.isPersonal || ReadOnly}
											inputProps={this.maxLength30}/>												
									</GridItem>
									<GridItem>
										<GenericTextInput
											Name="EmployerAddress"
											LabelText="Address"
											Id="employer-address"
											Value={model.EmployerAddress}
											ValueChanged={this.props.handleChange}
											Disabled={!tempModel.isPersonal || ReadOnly}
											inputProps={this.maxLength100} />
									</GridItem>								
									<GridItem>
										<GenericTextInput
											Name="EmployerZipCode"
											LabelText="Postal Code"
											Id="employer-postcode"
											Value={model.EmployerZipCode}
											ValueChanged={this.props.handleChange}
											Disabled={!tempModel.isPersonal || ReadOnly}
											inputProps={this.maxLength20} />
									</GridItem>
									<GridItem>
										<GenericSelectInput
											Name="EmployerCountryId"
											LabelText="Country"
											Method="POST"
											Url="/coreapi/v1.0/Country/GetAll"
											Parameter={{}}
											DataRoot="Item"
											KeyValueMember="Id"
											TextValueMember="Name"
											Value={model.EmployerCountryId}
											ValueChanged={this.props.handleChange}
											Disabled={!tempModel.isPersonal || ReadOnly}	/>
									</GridItem>
									<GridItem>
										<GenericSelectInput
											key={model.EmployerCountryId + "province"}
											Name="EmployerProvinceId"
											LabelText="Province"
											Method="POST"
											Url="/coreapi/v1.0/Province/Filter"
											Parameter={{ CountryId: model.EmployerCountryId }}
											DataRoot="Item"
											KeyValueMember="Id"
											TextValueMember="Name"
											Value={model.EmployerProvinceId}
											ValueChanged={this.props.handleChange}
											Disabled={!tempModel.isPersonal || ReadOnly}	/>
									</GridItem>
									<GridItem>
										<GenericSelectInput
											key={"city" + model.EmployerProvinceId + ""}
											Name="EmployerCityId"
											LabelText="City"
											Method="POST"
											Url="/coreapi/v1.0/City/Filter"
											Parameter={{ ProvinceId: model.EmployerProvinceId }}
											DataRoot="Item"
											KeyValueMember="Id"
											TextValueMember="Name"
											Value={model.EmployerCityId}
											ValueChanged={this.props.handleChange}
											Disabled={!tempModel.isPersonal || ReadOnly}	/>
									</GridItem>
									<GridItem>
										<GridContainer>
											<GridItem xs={8}>
												<GenericSelectInput
													Name="EmployerPhoneCountryCodeId"
													LabelText="Phone Number"
													TitleLabel="Country Code"
													LabelMd={6}
													Method="POST"
													Url="/coreapi/v1.0/Country/GetAll"
													Parameter={this.emptyObject}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember={"Code"}
													Value={model.EmployerPhoneCountryCodeId}
													ValueChanged={this.props.handleChange}
													Sorted={this.sortedOrderIndex}
													RenderItem={this.RenderItemPhoneCode}
													Disabled={!tempModel.isPersonal || ReadOnly}/>
											</GridItem>
											<GridItem xs={4} style={{ paddingRight: 2 + "px !important" }}>
												<GenericNumberInput
													IsPhone
													Name="EmployerPhoneNumber"
													InputStyle={this.marginLeft2}
													LabelMd={0}
													Value={model.EmployerPhoneNumber}
													ValueChanged={this.props.handleChange}
													MaxLength={10}
													Disabled={!tempModel.isPersonal || ReadOnly}/>
											</GridItem>
										</GridContainer>
									</GridItem>									
								</GridItem>																									
							</>														
						</GridItem>					
						<GridItem xs={4}>
							<GenericTitle text={"Communication Information"} />
							<>
								<GridItem>
									<GenericEmailInput
										Name="Email"
										LabelText="E-Mail"
										Value={model.Email}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly}
										inputProps={this.maxLength64}
										Required={(IsIncludePrepaid || IsIncludeLender)  && !IsFilledPhoneNumber && !ReadOnly}
										IsInvalid={vModel.Email} />
								</GridItem>
								<GridItem>
									<GridContainer>
										<GridItem xs={8}>
											<GenericSelectInput
												Name="PhoneCountryCodeId"
												LabelText="Mobile phone number"
												TitleLabel="Country Code"
												LabelMd={6}
												Method="POST"
												Url="/coreapi/v1.0/Country/GetAll"
												Parameter={this.emptyObject}
												DataRoot="Item"
												KeyValueMember="Id"
												TextValueMember={"Code"}
												Value={model.PhoneCountryCodeId}
												ValueChanged={this.props.handleChange}
												Sorted={this.sortedOrderIndex}
												RenderItem={this.RenderItemPhoneCode}
												Disabled={ReadOnly}
												Required={ (IsIncludePrepaid || IsIncludeLender) && !model.Email && !ReadOnly}
												IsInvalid={vModel.PhoneCountryCode} />
										</GridItem>
										<GridItem xs={4} style={{ paddingRight: 2 + "px !important" }}>
											<GenericNumberInput
												IsPhone
												Name="PhoneNumber"
												InputStyle={this.marginLeft2}
												LabelMd={0}
												Value={model.PhoneNumber}
												ValueChanged={this.props.handleChange}
												MaxLength={10}
												Disabled={ReadOnly}
												Required={ (IsIncludePrepaid || IsIncludeLender) && !model.Email && !ReadOnly}
												IsInvalid={vModel.PhoneNumber} />
										</GridItem>
									</GridContainer>
								</GridItem>

								<GridItem>
									<GridContainer>
										<GridItem xs={8}>
											<GenericSelectInput
												Name="HomePhoneCountryCodeId"
												LabelText="Home phone number"
												TitleLabel="Home Country Code"
												LabelMd={6}
												Method="POST"
												Url="/coreapi/v1.0/Country/GetAll"
												Parameter={this.emptyObject}
												DataRoot="Item"
												KeyValueMember="Id"
												TextValueMember={"Code"}
												Value={model.HomePhoneCountryCodeId}
												ValueChanged={this.props.handleChange}
												Sorted={this.sortedOrderIndex}
												RenderItem={this.RenderItemPhoneCode}
												Disabled={ReadOnly} />
										</GridItem>
										<GridItem xs={4} style={{ paddingRight: 2 + "px !important" }}>
											<GenericNumberInput
												IsPhone
												Name="HomePhoneNumber"
												InputStyle={this.marginLeft2}
												LabelMd={0}
												Value={model.HomePhoneNumber}
												ValueChanged={this.props.handleChange}
												MaxLength={10}
												Disabled={ReadOnly}
												IsInvalid={vModel.HomePhoneNumber} />
										</GridItem>
									</GridContainer>
								</GridItem>

								<GridItem>
									<GenericTextInput
										Name="AddressLine1"
										LabelText="Address Line 1"
										Id="street-address"
										Value={model.AddressLine1}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly}
										Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
										IsInvalid={vModel.AddressLine1}
										inputProps={this.maxLength100} />
								</GridItem>
								<GridItem>
									<GenericTextInput
										Name="AddressLine2"
										Id="street-address2"
										LabelText="Address Line 2"
										Value={model.AddressLine2}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly}
										inputProps={this.maxLength100} />
								</GridItem>
								<GridItem>
									<GenericTextInput
										Name="ZipCode"
										LabelText="Postal Code"
										Id="postcode"
										Value={model.ZipCode}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly}
										Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
										IsInvalid={vModel.PostalCode}	
										inputProps={this.maxLength20} />
								</GridItem>
								<GridItem>
									<GenericSelectInput
										Name="CountryId"
										LabelText="Country"
										Method="POST"
										Url="/coreapi/v1.0/Country/GetAll"
										Parameter={{}}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="Name"
										Value={model.CountryId}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly}
										Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
										IsInvalid={vModel.CountryId}
									/>
								</GridItem>
								<GridItem>
									<GenericSelectInput
										key={model.CountryId + "province"}
										Name="ProvinceId"
										LabelText="Province"
										Method="POST"
										Url="/coreapi/v1.0/Province/Filter"
										Parameter={{ CountryId: model.CountryId }}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="Name"
										Value={model.ProvinceId}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly}
										Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
										IsInvalid={vModel.ProvinceId}
									/>
								</GridItem>
								<GridItem>
									<GenericSelectInput
										key={"city" + model.ProvinceId + ""}
										Name="CityId"
										LabelText="City"
										Method="POST"
										Url="/coreapi/v1.0/City/Filter"
										Parameter={{ ProvinceId: model.ProvinceId }}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="Name"
										Value={model.CityId}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly}
										Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
										IsInvalid={vModel.CityId}
									/>
								</GridItem>

								<br/>
                        <GridItem>
									<GenericCheckInput
										Name="MailingAddressIsSameMyAddress"
										LabelText="My mailing address is the same as my address"
										Value={model.MailingAddressIsSameMyAddress || false}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly}
									/>
								</GridItem>
								<br/>
								<GridItem>
									<GridItem style={{ opacity: model.MailingAddressIsSameMyAddress ? 0.4 : 1 }}>
										<GenericTextInput
											Name="MailingAddressLine1"
											LabelText="Mailing Address Line 1"
											Id="mailing-street-address"
											Value={model.MailingAddressLine1}
											ValueChanged={this.props.handleChange}
											Disabled={ReadOnly || model.MailingAddressIsSameMyAddress}
											Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
											IsInvalid={vModel.MailingAddressLine1}
											inputProps={this.maxLength100} />
									</GridItem>
									<GridItem style={{ opacity: model.MailingAddressIsSameMyAddress ? 0.4 : 1 }}>
										<GenericTextInput
											Name="MailingAddressLine2"
											Id="mailing-street-address2"
											LabelText="Mailing Address Line 2"
											Value={model.MailingAddressLine2}
											ValueChanged={this.props.handleChange}
											Disabled={ReadOnly || model.MailingAddressIsSameMyAddress}
											inputProps={this.maxLength100} />
									</GridItem>
									<GridItem style={{ opacity: model.MailingAddressIsSameMyAddress ? 0.4 : 1 }}>
										<GenericTextInput
											Name="MailingZipCode"
											LabelText="Mailing Postal Code"
											Id="mailing-postcode"
											Value={model.MailingZipCode}
											ValueChanged={this.props.handleChange}
											Disabled={ReadOnly || model.MailingAddressIsSameMyAddress}
											Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
											IsInvalid={vModel.MailingPostalCode}	
											inputProps={this.maxLength20} />
									</GridItem>
									<GridItem style={{ opacity: model.MailingAddressIsSameMyAddress ? 0.4 : 1 }}>
										<GenericSelectInput
											Name="MailingCountryId"
											LabelText="Mailing Country"
											Method="POST"
											Url="/coreapi/v1.0/Country/GetAll"
											Parameter={{}}
											DataRoot="Item"
											KeyValueMember="Id"
											TextValueMember="Name"
											Value={model.MailingCountryId}
											ValueChanged={this.props.handleChange}
											Disabled={ReadOnly || model.MailingAddressIsSameMyAddress}
											Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
											IsInvalid={vModel.MailingCountryId}
										/>
									</GridItem>
									<GridItem style={{ opacity: model.MailingAddressIsSameMyAddress ? 0.4 : 1 }}>
										<GenericSelectInput
											key={model.MailingCountryId + "province"}
											Name="MailingProvinceId"
											LabelText="Mailing Province"
											Method="POST"
											Url="/coreapi/v1.0/Province/Filter"
											Parameter={{ CountryId: model.MailingCountryId }}
											DataRoot="Item"
											KeyValueMember="Id"
											TextValueMember="Name"
											Value={model.MailingProvinceId}
											ValueChanged={this.props.handleChange}
											Disabled={ReadOnly || model.MailingAddressIsSameMyAddress}
											Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
											IsInvalid={vModel.MailingProvinceId}
										/>
									</GridItem>
									<GridItem style={{ opacity: model.MailingAddressIsSameMyAddress ? 0.4 : 1 }}>
										<GenericSelectInput
											key={"city" + model.MailingProvinceId + ""}
											Name="MailingCityId"
											LabelText="Mailing City"
											Method="POST"
											Url="/coreapi/v1.0/City/Filter"
											Parameter={{ ProvinceId: model.MailingProvinceId }}
											DataRoot="Item"
											KeyValueMember="Id"
											TextValueMember="Name"
											Value={model.MailingCityId}
											ValueChanged={this.props.handleChange}
											Disabled={ReadOnly || model.MailingAddressIsSameMyAddress}
											Required={(IsIncludeLender || IsIncludePrepaid) && !ReadOnly}
											IsInvalid={vModel.MailingCityId}
										/>
									</GridItem>
									<GridItem>
										<GenericTextInput
											Name="MailingPoBox"
											LabelText="Mailing PObox"
											Value={model.MailingPoBox}
											ValueChanged={this.props.handleChange}
											Disabled={ReadOnly}
											inputProps={this.maxLength15}
											IsInvalid={vModel.MailingPoBox} />
									</GridItem>
								</GridItem>

								<GridItem >
									<GenericSelectInput
										Name="LanguageId"
										LabelText="Preferred Language"
										Method="POST"
										Url="/coreapi/v1.0/Parameter/Search"
										Parameter={this.ParameterLanguage}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="ParameterDesc"
										Value={model.LanguageId}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly} />
								</GridItem>
								<GridItem >
									<GenericSelectInput
										Name="HasTextNotificationId"
										LabelText="Text/SMS Notification"
										Method="POST"
										Url="/coreapi/v1.0/Parameter/Search"
										Parameter={this.ParameterYesNo}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="ParameterDesc"
										Value={model.HasTextNotificationId}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly} />
								</GridItem>
								<GridItem >
									<GenericSelectInput
										Name="HasEmailNotificationId"
										LabelText="E-Mail Notification"
										Method="POST"
										Url="/coreapi/v1.0/Parameter/Search"
										Parameter={this.ParameterYesNo}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="ParameterDesc"
										Value={model.HasEmailNotificationId}
										ValueChanged={this.props.handleChange}
										Disabled={ReadOnly} />
								</GridItem>
							</>
							{(IsIncludeLender || IsIncludePrepaid) &&							  		
									<GridItem>
										<br />
										<GenericTitle text={"Watchlist Check Results"} />
										<GridItem>
												<GenericTextInput
  													Name="SearchStatus"
  													LabelText="WatchList Status"													
													Value={wCheckModel.WatchListStatusDescription}								
  													Disabled={true}
 													inputProps={this.maxLength30} />
											</GridItem>
											<GridItem>
												<GenericTextInput
  													Name="SearchResult"
  													LabelText="Search Result"
  													Value={wCheckModel.SearchResult}									
  													Disabled={true}
 													inputProps={this.maxLength30} />
											</GridItem>											
											<GridItem>
												<GenericDateInput
  													Name="LastReviewDate"
  													LabelText="Last Review Date"
  													Value={wCheckModel.LastReviewDate 
															? DateHelper.ToMomentWithFormat(wCheckModel.LastReviewDate,"YYYY-MM-DD") 
															: ""} 	
													IncludeTime={false}
													IsPast={true}
													Utc={true}							
  													Disabled={true} />	
											</GridItem>
									</GridItem>
							  	}
							<GridItem style={{ opacity: disabledTaxQuestionary ? 0.4 : 1 }}>
										<GenericTitle text={"Tax Jurisdiction Questionnaire"} />
										<>
											<GridItem>
												<GenericCheckInput
													Name="CanadianTaxResident"
													LabelText="Is this cardholder a tax resident of Canada?"
													Value={model.CanadianTaxResident || false}
													ValueChanged={this.props.handleChange}
													Disabled={disabledTaxQuestionary || ReadOnly}
												/>
											</GridItem>
											<br/>
											<GridItem style={{ opacity: model.CanadianTaxResident ? 1 : 0.4 }}>
												<GenericTextInput
													Name="SIN"
													LabelText="Canadian Social Insurance Number (SIN)"
													inputProps={this.maxLength15}
													Value={model.SIN}
													ValueChanged={this.props.handleChange}
													Disabled={disabledTaxQuestionary || ReadOnly|| !model.CanadianTaxResident}
													Required={model.CanadianTaxResident && (model.AmericanTaxResident || model.ForeignTaxResident) }
													IsInvalid={vModel.SIN}
												/>
											</GridItem>
											<br/>
											<GridItem style={{ opacity: model.CanadianTaxResident ? 1 : 0.4 }}>
												<GridItem>
													<GenericCheckInput
														Name="AmericanTaxResident"
														LabelText="Is this cardholder a tax resident or citizen of the United States?"
														Value={model.AmericanTaxResident || false}
														ValueChanged={this.props.handleChange}
														Disabled={disabledTaxQuestionary || ReadOnly}
													/>
												</GridItem>
												<br/>
												<GridItem>
													<GenericTextInput
														Name="TIN"
														LabelText="American Tax Identification Number (TIN)"
														inputProps={this.maxLength15}
														Value={model.TIN}
														ValueChanged={this.props.handleChange}
														Disabled={disabledTaxQuestionary || ReadOnly || !model.AmericanTaxResident || model.AmericanHasNoTIN}
														Required={model.AmericanTaxResident && !model.AmericanHasNoTIN}
														IsInvalid={vModel.TIN}
													/>
												</GridItem>
											</GridItem>
											{model.AmericanTaxResident &&
											<GridItem>
												<GridItem>
													<GenericCheckInput
														Name="AmericanHasNoTIN"
														LabelText="Does not have this number?"
														Value={model.AmericanHasNoTIN || false}
														ValueChanged={this.props.handleChange}
														Disabled={disabledTaxQuestionary || ReadOnly}
													/>
												</GridItem>
												<GridItem style={{ opacity: model.AmericanHasNoTIN ? 1 : 0.4 }}>
													<GridItem>
														<GridItem>
															<GenericSelectInput
																Name="AmericanNoTinReasonId"
															   LabelText="Reason for not providing a TIN"
																Method="POST"
																Url="/coreapi/v1.0/Parameter/Search"
																Parameter={this.ParameterTaxJurisdictionQuestionnaireNoTinReason}
																DataRoot="Item"
																KeyValueMember="Id"
																TextValueMember="ParameterValue2"
																Sorted={this.sortedParameterValue2}
																Value={model.AmericanNoTinReasonId}
																ValueChanged={this.props.handleChange}
																Disabled={disabledTaxQuestionary || ReadOnly || !model.AmericanHasNoTIN}
																Required={model.AmericanHasNoTIN && !ReadOnly}
																IsInvalid={vModel.AmericanNoTinReasonId}
																/>
														</GridItem>
													</GridItem>
													<GridItem style={{ opacity: model.AmericanNoTinReasonId == 
																				this.state.taxJurisdictionQuestionnaireReasonIds
																					.find(x=>x.Value == CustomerTaxJurisdictionQuestionnaireReason.OtherReason).Id ? 1 : 0.4 }}>
														<GenericTextInput
															Name="AmericanNoTinOtherReason"
															LabelText="Reason"
															inputProps={this.maxLength60}
															Value={model.AmericanNoTinOtherReason}
															ValueChanged={this.props.handleChange}
															Disabled={disabledTaxQuestionary || ReadOnly || !model.AmericanHasNoTIN 
																|| (model.AmericanNoTinReasonId != 
																				this.state.taxJurisdictionQuestionnaireReasonIds
																					.find(x=>x.Value == CustomerTaxJurisdictionQuestionnaireReason.OtherReason).Id)
															 }
															IsInvalid={vModel.AmericanNoTinOtherReason}
															Required={model.AmericanHasNoTIN
																		&& (model.AmericanNoTinReasonId == 
																				this.state.taxJurisdictionQuestionnaireReasonIds
																					.find(x=>x.Value == CustomerTaxJurisdictionQuestionnaireReason.OtherReason).Id)
																		&& !ReadOnly}
														/>
													</GridItem>
												</GridItem>
											</GridItem>
											}
											<br/>
											<GridItem>
												<GenericCheckInput
													Name="ForeignTaxResident"
													LabelText="Is this cardholder a tax resident of a jurisdiction other than Canada or the United States?"
													Value={model.ForeignTaxResident || false}
													ValueChanged={this.props.handleChange}
													Disabled={disabledTaxQuestionary || ReadOnly}
												/>
											</GridItem>
											<br/>
											<GridItem style={{ opacity: !model.ForeignTaxResident ? 0.4 : 1 }}>
												<GridItem>
													<GenericTextInput
														Name="FTIN"
														LabelText="Foreign Tax Identification Number (FTIN)"
														inputProps={this.maxLength15}
														Value={model.FTIN}
														ValueChanged={this.props.handleChange}
														Disabled={disabledTaxQuestionary || ReadOnly || !model.ForeignTaxResident || model.ForeignHasNoFTIN}
														Required={model.ForeignTaxResident && !model.ForeignHasNoFTIN}
														IsInvalid={vModel.FTIN}
													/>
												</GridItem>
												{model.ForeignTaxResident &&
												<GridItem>
													<GridItem>
														<GenericCheckInput
															Name="ForeignHasNoFTIN"
															LabelText="Does not have this number?"
															Value={model.ForeignHasNoFTIN || false}
															ValueChanged={this.props.handleChange}
															Disabled={disabledTaxQuestionary || ReadOnly}
														/>
													</GridItem>
													<GridItem style={{ opacity: model.ForeignHasNoFTIN ? 1 : 0.4 }}>
														<GridItem>
															<GenericSelectInput
																Name="ForeignNoFtinReasonId"
																LabelText="Reason for not providing a FTIN"
																Method="POST"
																Url="/coreapi/v1.0/Parameter/Search"
																Parameter={this.ParameterTaxJurisdictionQuestionnaireNoTinReason}
																DataRoot="Item"
																KeyValueMember="Id"
																TextValueMember="ParameterValue2"
																Sorted={this.sortedParameterValue2}
																Value={model.ForeignNoFtinReasonId}
																ValueChanged={this.props.handleChange}
																Disabled={disabledTaxQuestionary || ReadOnly || !model.ForeignHasNoFTIN}
																Required={model.ForeignHasNoFTIN && !ReadOnly}
																IsInvalid={vModel.ForeignNoFtinReasonId}
																/>
														</GridItem>
														<GridItem style={{ opacity: model.ForeignNoFtinReasonId == 
																				this.state.taxJurisdictionQuestionnaireReasonIds
																					.find(x=>x.Value == CustomerTaxJurisdictionQuestionnaireReason.OtherReason).Id ? 1 : 0.4 }}>
															<GenericTextInput
																Name="ForeignNoFtinOtherReason"
																LabelText="Reason"
																inputProps={this.maxLength60}
																Value={model.ForeignNoFtinOtherReason}
																ValueChanged={this.props.handleChange}
																Disabled={disabledTaxQuestionary || ReadOnly || !model.ForeignHasNoFTIN
																	|| (model.ForeignNoFtinReasonId != 
																				this.state.taxJurisdictionQuestionnaireReasonIds
																					.find(x=>x.Value == CustomerTaxJurisdictionQuestionnaireReason.OtherReason).Id)
																}
																IsInvalid={vModel.ForeignNoFtinOtherReason}
															   Required={model.ForeignHasNoFTIN
																		&& (model.ForeignNoFtinReasonId == 
																				this.state.taxJurisdictionQuestionnaireReasonIds
																					.find(x=>x.Value == CustomerTaxJurisdictionQuestionnaireReason.OtherReason).Id)
																		&& !ReadOnly}
															/>
														</GridItem>
													</GridItem>
												</GridItem>
												}
											</GridItem>
											</>
							</GridItem>	
						</GridItem>
						<GridItem xs={4} style={{ opacity: disabledIdVerification ? 0.4 : 1 }}>
							<GenericTitle text={"ID Verification"} />
							<>
								<GridItem>
									<GenericSelectInput
										Name="IdentificationMethodId"
										LabelText="Identification Method"
										Method="POST"
										Url="/coreapi/v1.0/Parameter/Search"
										Parameter={this.ParameterIdentificationMethod}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="ParameterDesc"
										Value={model.IdentificationMethodId}
										ValueChanged={this.props.handleChange}
										Disabled={disabledIdVerification || ReadOnly}
										Required={tempModel.isPersonal == true 
														&& (IsIncludeLender || IsIncludePrepaid) && !ReadOnly}									
										IsInvalid={vModel.IdentificationMethodId} />
								</GridItem>
								
								{tempModel.isPersonal 
										&& (this.state.identificationMethodIds.length > 0)
									   && (this.state.identificationMethodIds
												  .find(x=>x.Value == IdentificationMethod.InPersonIDVerification).Id 
																			== model.IdentificationMethodId) 
										&&
									<GridItem> 
										<GridItem xs={4}>
											<br/>
											<b>Primary Identification</b>
										</GridItem>
										<GridItem>
											<GenericSelectInput
												Name="IdentityTypeId"
												LabelText="Identification Type"
												Method="POST"
												Url="/coreapi/v1.0/Parameter/Search"
												Parameter={this.ParameterIdentityType}
												DataRoot="Item"
												KeyValueMember="Id"
												TextValueMember="ParameterDesc"
												Sorted={this.sortedParameterDesc}
												Value={model.IdentityTypeId}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												Required={disabledIdVerification === false 
														&& tempModel.isPersonal 
														&& (model.IdentificationMethodId ==
																this.state.identificationMethodIds
																	.find(x=>x.Value == IdentificationMethod.InPersonIDVerification).Id)
														&& (IsIncludeLender || IsIncludePrepaid)
														&& !ReadOnly}
												IsInvalid={vModel.IdentityTypeId} />																	
										</GridItem>
										{tempModel.isPersonal &&
												this.specificIdentityTypesIds.includes(model.IdentityTypeId) &&
											<GridItem>
												<GenericSelectInput
													Name="PrimaryProvincialIdentityTypeId"
													LabelText="Provincial Id Type"
													Method="POST"
													Url="/coreapi/v1.0/Parameter/Search"
													Parameter={this.ParameterProvincialGovermentPhotoId}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="ParameterDesc"
													Sorted={this.sortedParameterDesc}
													Value={model.PrimaryProvincialIdentityTypeId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													Required={disabledIdVerification === false 
																&& tempModel.isPersonal 														
																&& this.specificIdentityTypesIds.includes(model.IdentityTypeId)
																&& (IsIncludeLender || IsIncludePrepaid)
																&& !ReadOnly}
													IsInvalid={vModel.PrimaryProvincialIdentityTypeId} />																	
											</GridItem>
										}									
										<GridItem>
											<GenericTextInput
												Name="IdentityPlaceOfIssue"
												Hidden={isRefugeeProtectionDoc}
												LabelText="ID Place of Issue"
												Value={model.IdentityPlaceOfIssue}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												Required={disabledIdVerification === false 
														&& tempModel.isPersonal 
														&& (model.IdentificationMethodId 
																== this.state.identificationMethodIds
																		 .find(x=>x.Value == IdentificationMethod.InPersonIDVerification).Id)
														&& (IsIncludeLender || IsIncludePrepaid)
														&& !ReadOnly}
												IsInvalid={vModel.IdentityPlaceOfIssue}
												inputProps={this.maxLength30} />
										</GridItem>
										<GridItem>
												<GenericSelectInput
													Name="CountryOfIssueId"
													LabelText="Country of Issue"
													Method="POST"
													Url="/coreapi/v1.0/Country/GetAll"
													Parameter={{}}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="Name"
													Value={model.CountryOfIssueId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly || isRefugeeProtectionDoc}
													IsInvalid={vModel.CountryOfIssueId}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.InPersonIDVerification).Id)
															&& !ReadOnly}
												/>
											</GridItem>
											<GridItem>
												<GenericSelectInput
													key={model.CountryOfIssueId + "province"}
													Name="ProvinceOfIssueId"
													Hidden={isRefugeeProtectionDoc}
													LabelText="Province of Issue"
													Method="POST"
													Url="/coreapi/v1.0/Province/Filter"
													Parameter={{ CountryId: model.CountryOfIssueId }}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="Name"
													Value={model.ProvinceOfIssueId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													IsInvalid={vModel.ProvinceOfIssueId}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.InPersonIDVerification).Id)
															&& !ReadOnly}
												/>
											</GridItem>
											{isRefugeeProtectionDoc &&
											<GridItem>
												<GenericLabel Text="Country of issue is recorded as Canada automatically, since this document is issued federally." />
											</GridItem>
											}
										<GridItem>
											<GenericTextInput
												Name="IdentityNumber"
												LabelText="ID No."
												Value={model.IdentityNumber}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												Required={disabledIdVerification === false 
														&& tempModel.isPersonal
														&& (IsIncludeLender || IsIncludePrepaid)
														&& (model.IdentificationMethodId == 
																this.state.identificationMethodIds
																	 .find(x=>x.Value == IdentificationMethod.InPersonIDVerification).Id)
														&& !ReadOnly}
												IsInvalid={vModel.IdentityNumber}
												inputProps={this.maxLength20} />
										</GridItem>
										<GridItem>
											<GenericDateInput
												key={model.IdentityTypeId}
												Name="IdentityExpireDate"
												LabelText="ID Exp Date"
												Value={model.IdentityExpireDate 
															? DateHelper.ToDateInputValue(model.IdentityExpireDate) 
															: ""}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												Required={disabledIdVerification === false 
														&& tempModel.isPersonal
														&& (IsIncludeLender || IsIncludePrepaid)
														&& (model.IdentificationMethodId == 
																this.state.identificationMethodIds
																	  .find(x=>x.Value==IdentificationMethod.InPersonIDVerification).Id)
														&& !ReadOnly}
												IsInvalid={vModel.IdentityExpireDate}
												IsFuture={true}
											/>
										</GridItem>
										<GridItem>
											<GenericTextInput
												Name="IdentityVerifiedBy"
												LabelText="Veryfied By"
												Value={model.IdentityVerifiedBy}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												Required={disabledIdVerification === false 
														&& tempModel.isPersonal
														&& (IsIncludeLender || IsIncludePrepaid)
														&& (model.IdentificationMethodId == 
																this.state.identificationMethodIds
																	 .find(x=>x.Value == IdentificationMethod.InPersonIDVerification).Id)
														&& !ReadOnly}
												IsInvalid={vModel.IdentityVerifiedBy}
												inputProps={this.maxLength20} />
										</GridItem>	
										<GridItem>
											<GenericDateInput
												Name="IdentityVerificationDate"
												LabelText="Verification Date"
												Value={model.IdentityVerificationDate 
															? DateHelper.ToDateInputValue(model.IdentityVerificationDate) 
															: ""}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												Required={disabledIdVerification === false 
														&& tempModel.isPersonal
														&& (IsIncludeLender || IsIncludePrepaid)
														&& (model.IdentificationMethodId == 
																this.state.identificationMethodIds
																	 .find(x=>x.Value == IdentificationMethod.InPersonIDVerification).Id)
														&& !ReadOnly}
												IsInvalid={vModel.IdentityVerificationDate}
											/>
										</GridItem>
										<GridItem xs={5}>
											<br/>
											<b>Secondary Identification</b>
										</GridItem>
										<GridItem>
											<GenericSelectInput
												Name="SecondaryIdentityTypeId"
												LabelText="Identification Type 2"
												Method="POST"
												Url="/coreapi/v1.0/Parameter/Search"
												Parameter={this.ParameterIdentitySecondary}
												DataRoot="Item"
												KeyValueMember="Id"
												TextValueMember="ParameterDesc"
												Sorted={this.sortedParameterDesc}
												Value={model.SecondaryIdentityTypeId}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}/>										
										</GridItem>
										{tempModel.isPersonal &&
											this.specificIdentityTypesIds.includes(model.SecondaryIdentityTypeId) &&
											<GridItem>
												<GenericSelectInput
													Name="SecondaryProvincialIdentityTypeId"
													LabelText="Provincial Id Type"
													Method="POST"
													Url="/coreapi/v1.0/Parameter/Search"
													Parameter={this.ParameterProvincialGovermentPhotoId}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="ParameterDesc"
													Sorted={this.sortedParameterDesc}
													Value={model.SecondaryProvincialIdentityTypeId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly} />																	
											</GridItem>
										}									
										<GridItem>
											<GenericTextInput
												Name="SecondaryIdentityPlaceOfIssue"
												Hidden={isSecondaryRefugeeProtectionDoc}
												LabelText="ID Place of Issue"
												Value={model.SecondaryIdentityPlaceOfIssue}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}									
												inputProps={this.maxLength30} />
										</GridItem>
										<GridItem>
												<GenericSelectInput
													Name="SecondaryCountryOfIssueId"
													LabelText="Country of Issue"
													Method="POST"
													Url="/coreapi/v1.0/Country/GetAll"
													Parameter={{}}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="Name"
													Value={model.SecondaryCountryOfIssueId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly || isSecondaryRefugeeProtectionDoc}
													IsInvalid={vModel.SecondaryCountryOfIssueId}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.InPersonIDVerification).Id)
															&& !ReadOnly && !isSecondaryRefugeeProtectionDoc}
												/>
											</GridItem>
											<GridItem>
												<GenericSelectInput
													key={model.SecondaryCountryOfIssueId + "province"}
													Name="SecondaryProvinceOfIssueId"
													Hidden={isSecondaryRefugeeProtectionDoc}
													LabelText="Province of Issue"
													Method="POST"
													Url="/coreapi/v1.0/Province/Filter"
													Parameter={{ CountryId: model.SecondaryCountryOfIssueId }}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="Name"
													Value={model.SecondaryProvinceOfIssueId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													IsInvalid={vModel.SecondaryProvinceOfIssueId}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.InPersonIDVerification).Id)
															&& !ReadOnly && !isSecondaryRefugeeProtectionDoc}
												/>
											</GridItem>
											{isSecondaryRefugeeProtectionDoc &&
											<GridItem>
												<GenericLabel Text="Country of issue is recorded as Canada automatically, since this document is issued federally." />
											</GridItem>
											}
										<GridItem>
											<GenericTextInput
												Name="SecondaryIdentityNumber"
												LabelText="ID No."
												Value={model.SecondaryIdentityNumber}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}									
												inputProps={this.maxLength20} />
										</GridItem>	
										<GridItem>
											<GenericDateInput
												key={model.SecondaryIdentityTypeId}
												Name="SecondaryIdentityExpireDate"
												LabelText="ID Exp Date"
												Value={model.SecondaryIdentityExpireDate 
															? DateHelper.ToDateInputValue(model.SecondaryIdentityExpireDate) 
															: ""}
												ValueChanged={this.props.handleChange}
												IsFuture={true}
												Disabled={disabledIdVerification || ReadOnly} />
										</GridItem>		
										<GridItem>
											<GenericTextInput
												Name="SecondaryIdentityVerifiedBy"
												LabelText="Verified By"
												Value={model.SecondaryIdentityVerifiedBy}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												inputProps={this.maxLength20} />
										</GridItem>	
										<GridItem>
											<GenericDateInput
												Name="SecondaryIdentityVerificationDate"
												LabelText="Verification Date"
												Value={model.SecondaryIdentityVerificationDate 
																	? DateHelper.ToDateInputValue(model.SecondaryIdentityVerificationDate) 
																	: ""}
												ValueChanged={this.props.handleChange}
												IsFuture={true}
												Disabled={disabledIdVerification || ReadOnly}												
											/>
										</GridItem>
									
									</GridItem>
								}		

								{tempModel.isPersonal
										&& (this.state.identificationMethodIds.length > 0)
										&& (this.state.identificationMethodIds
												.find(x=>x.Value == IdentificationMethod.CreditFileMethod).Id 
															== model.IdentificationMethodId) 
										&&
									<GridItem>
										<GridItem xs={5}>
											<br />
											<b>Credit File Information</b>
										</GridItem>
										<GridItem>
											<GenericSelectInput
												Name="CreditAgencyId"
												LabelText="Canadian credit bureau"
												Method="POST"
												Url="/coreapi/v1.0/Parameter/Search"
												Parameter={this.ParameterCreditAgency}
												DataRoot="Item"
												KeyValueMember="Id"
												TextValueMember="ParameterDesc"
												Sorted={this.sortedParameterDesc}
												Required={tempModel.isPersonal 
													&& disabledIdVerification === false
													&& (IsIncludeLender || IsIncludePrepaid)
													&& (model.IdentificationMethodId == 
															this.state.identificationMethodIds
																 .find(x=>x.Value == IdentificationMethod.CreditFileMethod).Id)
													&& !ReadOnly}
												Value={model.CreditAgencyId}
												ValueChanged={this.props.handleChange}
												IsInvalid={vModel.CreditAgencyId}
												Disabled={disabledIdVerification || ReadOnly}/>										
										</GridItem>
										<GridItem>
											<GenericTextInput
												Name="CreditFileNumber"
												LabelText="Credit File No"
												Required={tempModel.isPersonal 
													&& disabledIdVerification === false
													&& (IsIncludeLender || IsIncludePrepaid)
													&& (model.IdentificationMethodId == 
															this.state.identificationMethodIds
																 .find(x=>x.Value == IdentificationMethod.CreditFileMethod).Id)
													&& !ReadOnly}
												Value={model.CreditFileNumber}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												IsInvalid={vModel.CreditFileNumber}
												inputProps={this.maxLength20} />
										</GridItem>
										<GridItem>
											<GenericDateInput
												Name="CreditFileCompletionDate"
												LabelText="Verification Date"
												Value={model.CreditFileCompletionDate 
																	? DateHelper.ToDateInputValue(model.CreditFileCompletionDate) 
																	: ""}
												Required={tempModel.isPersonal 
													&& disabledIdVerification === false
													&& (IsIncludeLender || IsIncludePrepaid)
													&& (model.IdentificationMethodId == 
															this.state.identificationMethodIds
																 .find(x=>x.Value == IdentificationMethod.CreditFileMethod).Id)
													&& !ReadOnly}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												IsInvalid={vModel.CreditFileCompletionDate} 
											/>
										</GridItem>

									</GridItem>
								}

								{tempModel.isPersonal 
										&& (this.state.identificationMethodIds.length > 0)
										&& (this.state.identificationMethodIds
												  .find(x=>x.Value == IdentificationMethod.DualProcessMethod).Id == 
												  			model.IdentificationMethodId) 
										&&
									<GridItem>
										<GridItem xs={5}>
											<br/>
											<b>Primary Document</b>
										</GridItem>
										<GridItem>
											<GenericSelectInput
												Name="PrimaryDocumentId"
												LabelText="Document"
												Method="POST"
												Url="/coreapi/v1.0/Parameter/Search"
												Parameter={this.ParameterPrimarySourceForDualProcessId}
												DataRoot="Item"
												KeyValueMember="Id"
												TextValueMember="ParameterDesc"
												Required={tempModel.isPersonal 
													&& disabledIdVerification === false
													&& (IsIncludeLender || IsIncludePrepaid)
													&& (model.IdentificationMethodId == 
															this.state.identificationMethodIds
																 .find(x=>x.Value == IdentificationMethod.DualProcessMethod).Id)
													&& !ReadOnly}
												Sorted={this.sortedParameterDesc}
												Value={model.PrimaryDocumentId}
												ValueChanged={this.props.handleChange}
												IsInvalid={vModel.PrimaryDocumentId}
												Disabled={disabledIdVerification || ReadOnly}/>										
										</GridItem>
										<GridItem>
											<GenericDateInput
												Name="PrimaryDocumentVerificationDate"
												LabelText="Verification Date"
												Value={model.PrimaryDocumentVerificationDate 
															? DateHelper.ToDateInputValue(model.PrimaryDocumentVerificationDate) 
															: ""}
												ValueChanged={this.props.handleChange}
												Required={tempModel.isPersonal
													&& (IsIncludeLender || IsIncludePrepaid) 
													&& disabledIdVerification === false 
													&& (model.IdentificationMethodId == 
															this.state.identificationMethodIds
																 .find(x=>x.Value == IdentificationMethod.DualProcessMethod).Id)
													&& !ReadOnly}
												Disabled={disabledIdVerification || ReadOnly}
												IsInvalid={vModel.PrimaryDocumentVerificationDate} 
											/>
										</GridItem>
										<GridItem>
											<GenericTextInput
												Name="PrimaryDocumentNumber"
												LabelText="Associated No"
												Required={tempModel.isPersonal 
													&& disabledIdVerification === false
													&& (IsIncludeLender || IsIncludePrepaid) 
													&& (model.IdentificationMethodId == 
															this.state.identificationMethodIds
																 .find(x=>x.Value == IdentificationMethod.DualProcessMethod).Id)
													&& !ReadOnly}
												Value={model.PrimaryDocumentNumber}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												IsInvalid={vModel.PrimaryDocumentNumber}
												inputProps={this.maxLength20} />
										</GridItem>
										<GridItem>
											<GenericTextInput
												Name="PrimaryDocumentReviewedBy"
												LabelText="Reviewed By"
												Value={model.PrimaryDocumentReviewedBy}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												Required={tempModel.isPersonal 
													&& disabledIdVerification === false
													&& (IsIncludeLender || IsIncludePrepaid) 
													&& (model.IdentificationMethodId == 
															this.state.identificationMethodIds
																 .find(x=>x.Value == IdentificationMethod.DualProcessMethod).Id)
													&& !ReadOnly}
												IsInvalid={vModel.PrimaryDocumentReviewedBy}
												inputProps={this.maxLength20} />
										</GridItem>
										<GridItem xs={5}>
											<br/>
											<b>Secondary Document</b>
										</GridItem>
										<GridItem>
											<GenericSelectInput
												Name="SecondaryDocumentId"
												LabelText="Document"
												Method="POST"
												Url="/coreapi/v1.0/Parameter/Search"
												Parameter={this.ParameterSecondarySourceForDualProcessId}
												DataRoot="Item"
												KeyValueMember="Id"
												TextValueMember="ParameterDesc"
												Sorted={this.sortedParameterDesc}
												Value={model.SecondaryDocumentId}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}/>										
										</GridItem>
										<GridItem>
											<GenericDateInput
												Name="SecondaryDocumentVerificationDate"
												LabelText="Verification Date"
												Value={model.SecondaryDocumentVerificationDate 
																? DateHelper.ToDateInputValue(model.SecondaryDocumentVerificationDate) 
																: ""}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}												
											/>
										</GridItem>
										<GridItem>
											<GenericTextInput
												Name="SecondaryDocumentNumber"
												LabelText="Associated No"
												Value={model.SecondaryDocumentNumber}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												inputProps={this.maxLength20} />
										</GridItem>
										<GridItem>
											<GenericTextInput
												Name="SecondaryDocumentReviewedBy"
												LabelText="Reviewed By"
												Value = {model.SecondaryDocumentReviewedBy}
												ValueChanged={this.props.handleChange}
												Disabled={disabledIdVerification || ReadOnly}
												inputProps={this.maxLength20} />
										</GridItem>

									</GridItem>
								}		
								{tempModel.isPersonal 
										&& (this.state.identificationMethodIds.length > 0)
										&& (this.state.identificationMethodIds
												  .find(x=>x.Value == IdentificationMethod.DigitalIdentityVerification).Id == 
												  			model.IdentificationMethodId) 
										&&
										<GridItem>
											<GridItem>
												<GenericSelectInput
													Name="IdentityTypeId"
													LabelText="Identification Type"
													Method="POST"
													Url="/coreapi/v1.0/Parameter/Search"
													Parameter={this.ParameterIdentityType}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="ParameterDesc"
													Sorted={this.sortedParameterDesc}
													Value={model.IdentityTypeId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal 
															&& (model.IdentificationMethodId ==
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.DigitalIdentityVerification).Id)
															&& (IsIncludeLender || IsIncludePrepaid)
															&& !ReadOnly}
													IsInvalid={vModel.IdentityTypeId} />																	
											</GridItem>
											<GridItem>
												<GenericTextInput
													Name="IdentityPlaceOfIssue"
													Hidden={isRefugeeProtectionDoc}
													LabelText="ID Place of Issue"
													Value={model.IdentityPlaceOfIssue}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal 
															&& (model.IdentificationMethodId 
																	== this.state.identificationMethodIds
																			.find(x=>x.Value == IdentificationMethod.DigitalIdentityVerification).Id)
															&& (IsIncludeLender || IsIncludePrepaid)
															&& !ReadOnly}
													IsInvalid={vModel.IdentityPlaceOfIssue}
													inputProps={this.maxLength30} />
											</GridItem>
											<GridItem>
												<GenericTextInput
													Name="IdentityNumber"
													LabelText="ID No."
													Value={model.IdentityNumber}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.DigitalIdentityVerification).Id)
															&& !ReadOnly}
													IsInvalid={vModel.IdentityNumber}
													inputProps={this.maxLength20} />
											</GridItem>
											<GridItem>
												<GenericDateInput
													key={model.IdentityTypeId}
													Name="IdentityExpireDate"
													LabelText="ID Exp Date"
													Value={model.IdentityExpireDate 
																? DateHelper.ToDateInputValue(model.IdentityExpireDate) 
																: ""}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value==IdentificationMethod.DigitalIdentityVerification).Id)
															&& !ReadOnly}
													IsInvalid={vModel.IdentityExpireDate}
													IsFuture={true}
												/>
											</GridItem>
											<GridItem>
												<GenericSelectInput
													Name="CountryOfIssueId"
													LabelText="Country of Issue"
													Method="POST"
													Url="/coreapi/v1.0/Country/GetAll"
													Parameter={{}}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="Name"
													Value={model.CountryOfIssueId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly || isRefugeeProtectionDoc}
													IsInvalid={vModel.CountryOfIssueId}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.DigitalIdentityVerification).Id)
															&& !ReadOnly}
												/>
											</GridItem>
											<GridItem>
												<GenericSelectInput
													key={model.CountryOfIssueId + "province"}
													Name="ProvinceOfIssueId"
													Hidden={isRefugeeProtectionDoc}
													LabelText="Province of Issue"
													Method="POST"
													Url="/coreapi/v1.0/Province/Filter"
													Parameter={{ CountryId: model.CountryOfIssueId }}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="Name"
													Value={model.ProvinceOfIssueId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													IsInvalid={vModel.ProvinceOfIssueId}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.DigitalIdentityVerification).Id)
															&& !ReadOnly}
												/>
											</GridItem>
											{isRefugeeProtectionDoc &&
											<GridItem>
												<GenericLabel Text="Country of issue is recorded as Canada automatically, since this document is issued federally." />
											</GridItem>
											}
											<GridItem>
												<GenericDateInput
													Name="IdentityVerificationDate"
													LabelText="Verification Date"
													Value={model.IdentityVerificationDate 
																? DateHelper.ToDateInputValue(model.IdentityVerificationDate) 
																: ""}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.DigitalIdentityVerification).Id)
															&& !ReadOnly}
													IsInvalid={vModel.IdentityVerificationDate}
												/>
											</GridItem>
											
										</GridItem>
								}					
								{tempModel.isPersonal 
										&& (this.state.identificationMethodIds.length > 0)
										&& (this.state.identificationMethodIds
												  .find(x=>x.Value == IdentificationMethod.CanadaPostVerification).Id == 
												  			model.IdentificationMethodId) 
										&&
										<GridItem>
											<GridItem>
												<GenericSelectInput
													Name="IdentityTypeId"
													LabelText="Identification Type"
													Method="POST"
													Url="/coreapi/v1.0/Parameter/Search"
													Parameter={this.ParameterIdentityType}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="ParameterDesc"
													Sorted={this.sortedParameterDesc}
													Value={model.IdentityTypeId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal 
															&& (model.IdentificationMethodId ==
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.CanadaPostVerification).Id)
															&& (IsIncludeLender || IsIncludePrepaid)
															&& !ReadOnly}
													IsInvalid={vModel.IdentityTypeId} />																	
											</GridItem>
											<GridItem>
												<GenericTextInput
													Name="IdentityPlaceOfIssue"
													Hidden={isRefugeeProtectionDoc}
													LabelText="ID Place of Issue"
													Value={model.IdentityPlaceOfIssue}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal 
															&& (model.IdentificationMethodId 
																	== this.state.identificationMethodIds
																			.find(x=>x.Value == IdentificationMethod.CanadaPostVerification).Id)
															&& (IsIncludeLender || IsIncludePrepaid)
															&& !ReadOnly}
													IsInvalid={vModel.IdentityPlaceOfIssue}
													inputProps={this.maxLength30} />
											</GridItem>
											<GridItem>
												<GenericTextInput
													Name="IdentityNumber"
													LabelText="ID No."
													Value={model.IdentityNumber}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.CanadaPostVerification).Id)
															&& !ReadOnly}
													IsInvalid={vModel.IdentityNumber}
													inputProps={this.maxLength20} />
											</GridItem>
											<GridItem>
												<GenericDateInput
													key={model.IdentityTypeId}
													Name="IdentityExpireDate"
													LabelText="ID Exp Date"
													Value={model.IdentityExpireDate 
																? DateHelper.ToDateInputValue(model.IdentityExpireDate) 
																: ""}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value==IdentificationMethod.CanadaPostVerification).Id)
															&& !ReadOnly}
													IsInvalid={vModel.IdentityExpireDate}
													IsFuture={true}
												/>
											</GridItem>
											<GridItem>
												<GenericSelectInput
													Name="CountryOfIssueId"
													LabelText="Country of Issue"
													Method="POST"
													Url="/coreapi/v1.0/Country/GetAll"
													Parameter={{}}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="Name"
													Value={model.CountryOfIssueId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly || isRefugeeProtectionDoc}
													IsInvalid={vModel.CountryOfIssueId}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.CanadaPostVerification).Id)
															&& !ReadOnly}
												/>
											</GridItem>
											<GridItem>
												<GenericSelectInput
													key={model.CountryOfIssueId + "province"}
													Name="ProvinceOfIssueId"
													Hidden={isRefugeeProtectionDoc}
													LabelText="Province of Issue"
													Method="POST"
													Url="/coreapi/v1.0/Province/Filter"
													Parameter={{ CountryId: model.CountryOfIssueId }}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="Name"
													Value={model.ProvinceOfIssueId}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													IsInvalid={vModel.ProvinceOfIssueId}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.CanadaPostVerification).Id)
															&& !ReadOnly}
												/>
											</GridItem>
											{isRefugeeProtectionDoc &&
											<GridItem>
												<GenericLabel Text="Country of issue is recorded as Canada automatically, since this document is issued federally." />
											</GridItem>
											}
											<GridItem>
												<GenericDateInput
													Name="IdentityVerificationDate"
													LabelText="Verification Date"
													Value={model.IdentityVerificationDate 
																? DateHelper.ToDateInputValue(model.IdentityVerificationDate) 
																: ""}
													ValueChanged={this.props.handleChange}
													Disabled={disabledIdVerification || ReadOnly}
													Required={disabledIdVerification === false 
															&& tempModel.isPersonal
															&& (IsIncludeLender || IsIncludePrepaid)
															&& (model.IdentificationMethodId == 
																	this.state.identificationMethodIds
																		.find(x=>x.Value == IdentificationMethod.CanadaPostVerification).Id)
															&& !ReadOnly}
													IsInvalid={vModel.IdentityVerificationDate}
												/>
											</GridItem>
											
										</GridItem>
								}								
								<GridItem>
									<br />
								</GridItem>			
								<GridItem>
									<GenericSelectInput
										Name="CountryOfCitizenShipId"
										LabelText="Country of Citizenship"
										Method="POST"
										Url="/coreapi/v1.0/Country/GetAll"
										Parameter={this.emptyObject}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="Name"
										Value={model.CountryOfCitizenShipId}
										ValueChanged={this.props.handleChange}
										Disabled={disabledIdVerification || ReadOnly}
									/>
								</GridItem>
								<GridItem>
									<GenericSelectInput
										Name="CountryOfBirthId"
										LabelText="Country of Birth"
										Method="POST"
										Url="/coreapi/v1.0/Country/GetAll"
										Parameter={this.emptyObject}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="Name"
										Value={model.CountryOfBirthId}
										ValueChanged={this.props.handleChange}
										Disabled={disabledIdVerification || ReadOnly} />
								</GridItem>
								<GridItem>
									<GenericSelectInput
										Name="CountryOfResidentId"
										LabelText="Residence Situation"
										Method="POST"
										Url="/coreapi/v1.0/Parameter/Search"
										Parameter={this.ParameterResidencyCountry}
										DataRoot="Item"
										KeyValueMember="Id"
										TextValueMember="ParameterDesc"
										Value={model.CountryOfResidentId}
										ValueChanged={this.props.handleChange}
										Disabled={disabledIdVerification || ReadOnly} />
								</GridItem>
							</>
						</GridItem>
						{(IsIncludeET && !ForInsert) &&
							<GridItem xs={12}>
								<GridContainer justify="flex-end">
									<GridItem>
										<Button size="sm" color="black" disabled={Disabled} onClick={this.props.handleNext}>Next</Button>
									</GridItem>
								</GridContainer>
							</GridItem>
						}
					</GridContainer>
				</GenericExpansionPanel>
		);
	}
}

CustomerInformationComponent.propTypes = {
	classes: PropTypes.object.isRequired,
	model: PropTypes.object,
	tempModel: PropTypes.object,
	wCheckModel: PropTypes.object,
	vModel: PropTypes.object,
	handleChange: PropTypes.func,
	handleNext: PropTypes.func,
	Title: PropTypes.string,
	ReadOnly: PropTypes.bool,
	Disabled: PropTypes.bool,
	ForInsert: PropTypes.bool
};

export default withArtifex(CustomerInformationComponent, {});